module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-pers clearfix",
    attrs: {
      "id": "pers-tab1",
      "name": "hrms32e-tab1"
    }
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-6 pull-left"
  }, [_c('div', {
    staticClass: "col-xs-12 card-ui clearfix border-top-color-skin"
  }, [_c('div', {
    staticClass: "sub-topic-box clearfix",
    on: {
      "click": _vm.toggleSubTopic1
    }
  }, [_c('i', {
    staticClass: "fa fa-user icon-sub-topic",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "sub-topic"
  }, [_vm._v(_vm._s(_vm.labels['HRMS32EC2']['20']))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.subTopic1),
      expression: "subTopic1"
    }],
    staticClass: "data-box clearfix"
  }, [_c('div', {
    staticClass: "data-row clearfix"
  }, [_c('div', {
    staticClass: "col-xs-5 data-label"
  }, [_vm._v(_vm._s(_vm.labels['HRES32EC2']['40']))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-7 data-input-stable"
  }, [_vm._v(_vm._s(_vm.dropdowns.codtitle[_vm.nowLang][_vm.detail.codtitle]))])]), _vm._v(" "), _c('div', {
    staticClass: "data-row clearfix"
  }, [_c('div', {
    staticClass: "col-xs-5 data-label"
  }, [_vm._v(_vm._s(_vm.labels['HRES32EC2']['50']))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-7 data-input-stable"
  }, [_vm._v(_vm._s(_vm.detail.namet))])]), _vm._v(" "), _c('div', {
    staticClass: "data-row clearfix"
  }, [_c('div', {
    staticClass: "col-xs-5 data-label"
  }, [_vm._v(_vm._s(_vm.labels['HRES32EC2']['60']))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-7 data-input-stable"
  }, [_vm._v(_vm._s(_vm.detail.lastt))])]), _vm._v(" "), _c('div', {
    staticClass: "data-row clearfix"
  }, [_c('div', {
    staticClass: "col-xs-5 data-label"
  }, [_vm._v(_vm._s(_vm.labels['HRES32EC2']['80']))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-7 data-input-stable"
  }, [_vm._v(_vm._s(_vm.detail.namee))])]), _vm._v(" "), _c('div', {
    staticClass: "data-row clearfix"
  }, [_c('div', {
    staticClass: "col-xs-5 data-label"
  }, [_vm._v(_vm._s(_vm.labels['HRES32EC2']['90']))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-7 data-input-stable"
  }, [_vm._v(_vm._s(_vm.detail.laste))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-6 pull-right"
  }, [_c('div', {
    staticClass: "col-xs-12 card-ui clearfix border-top-color-skin"
  }, [_c('div', {
    staticClass: "sub-topic-box clearfix",
    on: {
      "click": _vm.toggleSubTopic2
    }
  }, [_c('i', {
    staticClass: "fa fa-user icon-sub-topic",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "sub-topic"
  }, [_vm._v(_vm._s(_vm.labels['HRMS32EC2']['30']))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.subTopic2),
      expression: "subTopic2"
    }],
    staticClass: "data-box clearfix"
  }, [_c('div', {
    staticClass: "data-row clearfix"
  }, [_c('div', {
    staticClass: "col-xs-5 data-label"
  }, [_vm._v(_vm._s(_vm.labels['HRMS32EC2']['40']))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-7 data-input"
  }, [_c('hrms-dropdown', {
    staticStyle: {
      "margin-bottom": "5px"
    },
    attrs: {
      "options": _vm.dropdowns.codtitle[_vm.nowLang]
    },
    model: {
      value: (_vm.paramDetails.n_codtitle),
      callback: function($$v) {
        _vm.$set(_vm.paramDetails, "n_codtitle", $$v)
      },
      expression: "paramDetails.n_codtitle"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "data-row clearfix"
  }, [_c('div', {
    staticClass: "col-xs-5 data-label"
  }, [_vm._v(_vm._s(_vm.labels['HRES32EC2']['50']))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-7 data-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.paramDetails.n_namet),
      expression: "paramDetails.n_namet"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('max:30'),
      expression: "'max:30'"
    }],
    staticClass: "form-control input-text",
    attrs: {
      "type": "text",
      "id": "n_namet",
      "name": "n_namet",
      "maxlength": "30",
      "data-vv-name": "n_namet",
      "data-vv-as": "n_namet",
      "has-error": _vm.errors.has('n_namet')
    },
    domProps: {
      "value": (_vm.paramDetails.n_namet)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.paramDetails, "n_namet", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('n_namet')),
      expression: "errors.has('n_namet')"
    }],
    staticClass: "text-error"
  }, [_vm._v(_vm._s(_vm.errors.first('n_namet')))])])]), _vm._v(" "), _c('div', {
    staticClass: "data-row clearfix"
  }, [_c('div', {
    staticClass: "col-xs-5 data-label"
  }, [_vm._v(_vm._s(_vm.labels['HRES32EC2']['60']))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-7 data-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.paramDetails.n_lastt),
      expression: "paramDetails.n_lastt"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('max:30'),
      expression: "'max:30'"
    }],
    staticClass: "form-control input-text",
    attrs: {
      "type": "text",
      "id": "n_lastt",
      "name": "n_lastt",
      "maxlength": "30",
      "data-vv-name": "n_lastt",
      "data-vv-as": "n_lastt",
      "has-error": _vm.errors.has('n_lastt')
    },
    domProps: {
      "value": (_vm.paramDetails.n_lastt)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.paramDetails, "n_lastt", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('n_lastt')),
      expression: "errors.has('n_lastt')"
    }],
    staticClass: "text-error"
  }, [_vm._v(_vm._s(_vm.errors.first('n_lastt')))])])]), _vm._v(" "), _c('div', {
    staticClass: "data-row clearfix"
  }, [_c('div', {
    staticClass: "col-xs-5 data-label"
  }, [_vm._v(_vm._s(_vm.labels['HRES32EC2']['80']))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-7 data-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.paramDetails.n_namee),
      expression: "paramDetails.n_namee"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('max:30'),
      expression: "'max:30'"
    }],
    staticClass: "form-control input-text",
    attrs: {
      "type": "text",
      "id": "n_namee",
      "name": "n_namee",
      "maxlength": "30",
      "data-vv-name": "n_namee",
      "data-vv-as": "n_namee",
      "has-error": _vm.errors.has('n_namee')
    },
    domProps: {
      "value": (_vm.paramDetails.n_namee)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.paramDetails, "n_namee", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('n_namee')),
      expression: "errors.has('n_namee')"
    }],
    staticClass: "text-error"
  }, [_vm._v(_vm._s(_vm.errors.first('n_namee')))])])]), _vm._v(" "), _c('div', {
    staticClass: "data-row clearfix"
  }, [_c('div', {
    staticClass: "col-xs-5 data-label"
  }, [_vm._v(_vm._s(_vm.labels['HRES32EC2']['90']))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-7 data-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.paramDetails.n_laste),
      expression: "paramDetails.n_laste"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('max:30'),
      expression: "'max:30'"
    }],
    staticClass: "form-control input-text",
    attrs: {
      "type": "text",
      "id": "n_laste",
      "name": "n_laste",
      "maxlength": "30",
      "data-vv-name": "n_laste",
      "data-vv-as": "n_laste",
      "has-error": _vm.errors.has('n_laste')
    },
    domProps: {
      "value": (_vm.paramDetails.n_laste)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.paramDetails, "n_laste", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('n_laste')),
      expression: "errors.has('n_laste')"
    }],
    staticClass: "text-error"
  }, [_vm._v(_vm._s(_vm.errors.first('n_laste')))])])]), _vm._v(" "), _c('div', {
    staticClass: "data-row clearfix"
  }, [_c('div', {
    staticClass: "col-xs-5 data-label"
  }, [_vm._v(_vm._s(_vm.labels['HRMS32EC2']['70']))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-7 data-input"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.paramDetails.desnote),
      expression: "paramDetails.desnote"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('max:100'),
      expression: "'max:100'"
    }],
    staticClass: "form-control textarea-text",
    attrs: {
      "id": "desnote",
      "name": "desnote",
      "maxlength": "100",
      "data-vv-name": "desnote",
      "has-error": _vm.errors.has('desnote')
    },
    domProps: {
      "value": (_vm.paramDetails.desnote)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.paramDetails, "desnote", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('desnote')),
      expression: "errors.has('desnote')"
    }],
    staticClass: "text-error"
  }, [_vm._v(_vm._s(_vm.errors.first('desnote')))]), _vm._v(" "), _c('div', {
    staticClass: "remark-limit-character"
  }, [_vm._v(_vm._s(_vm.dispLimitLabel(100)))])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 box-footer"
  }, [_c('button', {
    staticClass: "btn bg-dark-gray",
    attrs: {
      "type": "button",
      "value": "Back"
    },
    on: {
      "click": function($event) {
        _vm.togglePage(0)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-circle-left"
  }), _vm._v(_vm._s(_vm.labelsButton['back']))]), _vm._v(" "), (_vm.validateStaappr) ? _c('button', {
    staticClass: "btn bg-color-skin",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.callSave()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-check-circle"
  }), _vm._v(_vm._s(_vm.labelsButton['save']))]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-493ee02c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/hrms32e/tab1.vue
// module id = 3732
// module chunks = 1